const lang: any = {
    typeHere: {
        PT: 'Digite algo',
        US: 'Type here',
        ES: 'Digite aquí'
    },
}   

export default lang